import * as React from "react";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import {
  cardImg,
  card,
  imgOverlay,
  brandImage,
  cardBody,
  cardTitle,
  cardText,
  cardFooter,
} from "./Brand.module.scss";

export const BrandCard: React.FC<any> = (props) => {
  return (
    <div className={card} id={props.id}>
      {props.children}
    </div>
  );
};

export const BrandImageLink: React.FC<any> = (props) => {
  const { path, name, image } = props;
  return (
    <Link
      to={path}
      title={name}
      aria-label={name}
      className={cardImg}
      id={props.id}
    >
      <BrandImage image={image} brand={name} />
    </Link>
  );
};

export const BrandImage: React.FC<any> = (props) => {
  return (
    <GatsbyImage image={props.image} alt={props.brand} className={brandImage} />
  );
};

export const ImgOverlay: React.FC<any> = (props) => {
  return <div className={imgOverlay}>{props.children}</div>;
};

export const BrandBody: React.FC<any> = (props) => {
  const { logo, content, alt } = props;
  return (
    <div className={cardBody}>
      <h2 className={cardTitle} id={"brand-title"}>
        <img src={logo.publicUrl} alt={alt} />
      </h2>
      <div
        className={cardText}
        id={"brand-description"}
        dangerouslySetInnerHTML={{
          __html: content !== null ? content.processed : "",
        }}
      ></div>
    </div>
  );
};

export const BrandFooter: React.FC<any> = (props) => {
  const { brandPath, name } = props;
  return (
    <div className={cardFooter}>
      <Link to={brandPath} aria-label={`Explore Brand ${name}`} id={props.id}>
        Explore Brand
      </Link>
    </div>
  );
};
